export const UPDATE_FIELD_ATTRIBUTE = '@authentication/updateAttribute';
export const SEND_RESPONSE = '@chatbot/sendResponse';
export const LISTENER_RESPONSE = '@chatbot/listenerResponse';
export const LISTENER_RESPONSE_SUCCESS = '@chatBot/listenerResponseSuccess';
export const LISTENER_RESPONSE_ERROR = '@chatBot/listenerResponseError';
export const TEXT_RESPONSE = '@chatbot/TEXTResponse';
export const START_CONVERSATION = '@chatbot/startConversation';
export const LOAD_CONVERSATION = '@chatbot/loadConversation';
export const START_CONVERSATION_SUCCESS = '@chatbot/startConversationSuccess';
export const FORM_ENCUESTA = '@chatbot/enviarEncuesta';
export const FORM_ENCUESTA_SUCCESS = '@chatbot/enviarEncuestaSuccess';
export const FORM_ENCUESTA_ERROR = '@chatbot/enviarEncuestaError';
export const START_WIDGET = '@chatbot/startWidget';
export const START_WIDGET_ERROR = '@chatbot/startWidgetError';
export const START_WIDGET_SUCCES = '@chatbot/startWidgetSucces';
export const PLAY_SOUND = '@chatbot/playSound';
export const ENCUESTA_CONF = "@chatbot/obtenerInfoConfEncuesta";
export const ENCUESTA_CONF_SUCCESS = "@chatbot/obtenerInfoConfEncuestaSuccess";
export const SHOW_WIDGET = "@chatbot/mostrarWidget";
export const SHOW_WIDGET_SUCCESS = "@chatbot/mostrarWidgetSuccess";
export const CHANGE_FLAG_WIDGET = "@chatbot/changeFlagShowWidget";
export const HANDLER_FILE_MESSAGE = "@chatbot/handleFileMessage";
export const HANDLER_FILE_MESSAGE_SUCCESS = "@chatbot/handleFileMessageSuccess";
export const SVG_ICONO_EQUIS = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgMzU3IDM1NyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzU3IDM1NzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnIGlkPSJjbGVhciI+CgkJPHBvbHlnb24gcG9pbnRzPSIzNTcsMzUuNyAzMjEuMywwIDE3OC41LDE0Mi44IDM1LjcsMCAwLDM1LjcgMTQyLjgsMTc4LjUgMCwzMjEuMyAzNS43LDM1NyAxNzguNSwyMTQuMiAzMjEuMywzNTcgMzU3LDMyMS4zICAgICAyMTQuMiwxNzguNSAgICIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo="
export const SENDING_MSG_DF = "@chatbot/sendingMessageDialogFlow";
export const CLIENTE_ALCALDIA = "1029";
export const CLIENTE_IDEAM = "1031";
export const CLIENTE_AGN = "1032";
export const ICONO_SEND_OSCURO = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0id2luZG93cy0xMjUyIj8+DQo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MzUuNSA1MzUuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTM1LjUgNTM1LjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnIGlkPSJzZW5kIj4NCgkJPHBvbHlnb24gcG9pbnRzPSIwLDQ5Ny4yNSA1MzUuNSwyNjcuNzUgMCwzOC4yNSAwLDIxNi43NSAzODIuNSwyNjcuNzUgMCwzMTguNzUgICAiIGZpbGw9InJnYmEoMCwgMCwgMCwgMC41NCkiLz4NCgk8L2c+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4="
export const INICIAR_CHAT_ABIERTO = "@chatbot/iniciarChatAbierto";
export const CAMBIAR_ESTADO_CHAT_ABIERTO = "@chatbot/cambiarEstadoChatAbierto";
export const TYPE_WRITER_WIDGET_WEB_SUCCESS = '@chatbot/typeWriterWidgetWebSuccess';
export const CONSULTA_TYPE_WRITER_WEB = '@chatbot/consultaTypeWriterWeb';
export const SEND_ACTION_CAROUSEL_SUCCESS = '@chatbot/sendActionCarouselSuccess';
export const ICONO_SEND_RED = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0id2luZG93cy0xMjUyIj8+DQo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MzUuNSA1MzUuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTM1LjUgNTM1LjU7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnIGlkPSJzZW5kIj4NCgkJPHBvbHlnb24gcG9pbnRzPSIwLDQ5Ny4yNSA1MzUuNSwyNjcuNzUgMCwzOC4yNSAwLDIxNi43NSAzODIuNSwyNjcuNzUgMCwzMTguNzUgICAiIGZpbGw9InJnYmEoMjE1LDM0LDM0LDAuNzY4NjI3NDUwOTgwMzkyMikiLz4NCgk8L2c+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4="

export const RESPONSE_MESSAGES = [
    {
        id: 'nx-001',
        message: 'Unsupported platform',
        user: 'bnet'
    },
    {
        id: 'nx-002',
        message: 'Lorem ipsum',
        user: 'bnet'
    },
    {
        id: 'nx-003',
        message: 'contributors and audited',
        user: 'bnet'
    },
    {
        id: 'nx-035',
        message: 'fWindows PowerShell',
        user: 'bnet'
    },
    {
        id: 'nx-004',
        message: 'found 1 high severity vulnerability',
        user: 'bnet'
    },
    {
        id: 'nx-005',
        message: 'Microsoft Corporation. All rights reserved.',
        user: 'bnet'
    },
    {
        id: 'nx-006',
        message: 'Switched to a new branch',
        user: 'bnet'
    },
    {
        id: 'nx-007',
        message: 'Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License',
        user: 'bnet'
    },
    {
        id: 'nx-008',
        message: 'You must install peer dependencies yo',
        user: 'bnet'
    },
    {
        id: 'nx-009',
        message: 'packages from 6 contributors and audited 1673',
        user: 'bnet'
    },
    {
        id: 'nx-010',
        message: 'fWindows PowerShell',
        user: 'bnet'
    }
];

export const COMPANY_FORM_TITLE = 'Chat SFC';


export const getLoginButton = (handlerSafe, handlerCancel) => {
    return [
        {
            label: "Enviar",
            className: "auth-btn-send",
            action: false,
            style: "primary",
            primary: true,
            onClick: handlerSafe
        }
    ]
}

export const getEncuestaButton = (handlerSafe) => {

    return [
        {
            label: "Enviar",
            className: "auth-btn-send",
            action: false,
            style: "primary",
            onClick: handlerSafe
        }
    ]
}
